import LoginRegisterTab from '../../../organisms/customer/guest/login-register-tab'
import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { RESTRICTION_MODE_LOGIN_REGISTER } from '@bluheadless/ui-logic/src/constants'
import Login from '../../../organisms/customer/guest/login/login'

const LoginPageComponent = ({ dynamicAreasLogin, dynamicAreasRegister }) => {
	const {
		restriction: { enabled, mode },
	} = useConfig()

	return !enabled || (enabled && mode === RESTRICTION_MODE_LOGIN_REGISTER) ? (
		<LoginRegisterTab
			defaultTab="login"
			dynamicAreasLogin={dynamicAreasLogin}
			dynamicAreasRegister={dynamicAreasRegister}
		/>
	) : (
		<Login dynamicAreas={dynamicAreasLogin} key="login" />
	)
}

LoginPageComponent.defaultProps = {}
LoginPageComponent.propTypes = {}

export default LoginPageComponent
